export default class ExchangeRates {
    constructor(element) {
        this.selector = element;

        this.openDropdown();
        this.closeDropdown();
        this.searchDropdown();
        this.chooseDropdownOption();
        this.changeInputValue();
        this.switch();
        this.refresh();
    }

    openDropdown() {
        const dropdowns = this.selector.querySelectorAll('[data-dropdown]');

        dropdowns.forEach((dropdown) => {
            const selector = dropdown.querySelector('[data-dropdown-selector]');
            const list = dropdown.querySelector('[data-dropdown-list]');

            selector.addEventListener('click', () => {
                list.classList.remove('hidden');

                if (window.innerWidth < 640) {
                    document.body.classList.add('overflow-hidden');
                }
            });
        });
    }

    closeDropdown() {
        const dropdowns = this.selector.querySelectorAll('[data-dropdown]');
        const buttons = this.selector.querySelectorAll('[data-dropdown-close]');

        window.addEventListener('click', function(event) {
            dropdowns.forEach((dropdown) => {
                const list = dropdown.querySelector('[data-dropdown-list]');
                const selector = dropdown.querySelector('[data-dropdown-selector]');

                if (!selector.contains(event.target) && !list.contains(event.target)) {
                    list.classList.add('hidden');
                }
            });
        });

        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const list = button.closest('[data-dropdown-list]');

                list.classList.add('hidden');
                document.body.classList.remove('overflow-hidden');
            });
        });
    }

    searchDropdown() {
        const inputs = this.selector.querySelectorAll('[data-dropdown-search-input]');

        inputs.forEach((input) => {
            input.addEventListener('input', () => {
                const dropdown = input.closest('[data-dropdown]');
                const results = dropdown.querySelector('[data-dropdown-results]');
                const options = results.querySelectorAll('[data-dropdown-option]');
                const value = input.value.toLowerCase();

                options.forEach((option) => {
                    const text = option.querySelector('[data-dropdown-option-title]');

                    if (
                        option.dataset.dropdownOption.toLowerCase().includes(value) ||
                        text.innerText.toLowerCase().includes(value)
                    ) {
                        option.classList.remove('hidden');
                    } else {
                        option.classList.add('hidden');
                    }
                });
            });
        });
    }

    chooseDropdownOption() {
        this.selector.addEventListener('click', (event) => {
            const option = event.target.closest('[data-dropdown-option]');

            if (!option) {
                return;
            }

            const dropdown = option.closest('[data-dropdown]');
            const list = dropdown.querySelector('[data-dropdown-list]');

            list.classList.add('hidden');
            document.body.classList.remove('overflow-hidden');

            window.exchange_rates_data[dropdown.dataset.dropdown] = option.dataset.dropdownOption;

            this.renderBaseDropdown();
            this.renderTargetDropdown();
            this.updateCurrencies();
        });
    }

    renderBaseDropdown() {
        const dropdown = this.selector.querySelector('[data-dropdown="base"]');
        const price = this.selector.querySelector('[data-base-price]');
        const results = dropdown.querySelector('[data-dropdown-results]');
        const label = dropdown.querySelector('[data-dropdown-selector-label]');
        const image = dropdown.querySelector('[data-dropdown-selector-image]');

        results.innerHTML = '';

        for (const currency of window.exchange_rates_data.data) {
            results.insertAdjacentHTML('beforeend', this.formatDropdownOption(currency));
        }

        label.innerHTML = window.exchange_rates_data.base;
        price.innerHTML = `1 ${window.exchange_rates_data.base}`;
        image.setAttribute('src', `${window.exchange_rates_data.icon_directory_uri}/dist/images/currency-icons/${window.exchange_rates_data.base}.svg`);

        const activeOption = dropdown.querySelector(`[data-dropdown-option="${window.exchange_rates_data.base}"]`);
        activeOption.classList.add('option-active');
    }

    renderTargetDropdown() {
        const dropdown = this.selector.querySelector('[data-dropdown="target"]');
        const price = this.selector.querySelector('[data-target-price]');
        const results = dropdown.querySelector('[data-dropdown-results]');
        const label = dropdown.querySelector('[data-dropdown-selector-label]');
        const image = dropdown.querySelector('[data-dropdown-selector-image]');

        const baseInput = this.selector.querySelector('[data-dropdown-input="base"]');
        const targetInput = this.selector.querySelector('[data-dropdown-input="target"]');

        const baseCurrency = window.exchange_rates_data.data.find(obj => obj.symbol === window.exchange_rates_data.base);
        let targetCurrency = baseCurrency.rates.find(obj => obj.symbol === window.exchange_rates_data.target);

        if (targetCurrency === undefined) {
            window.exchange_rates_data.target = baseCurrency.rates[0].symbol;
            targetCurrency = baseCurrency.rates.find(obj => obj.symbol === window.exchange_rates_data.target);
        }

        results.innerHTML = '';

        for (const currency of baseCurrency.rates) {
            results.insertAdjacentHTML('beforeend', this.formatDropdownOption(currency));
        }

        label.innerHTML = targetCurrency.symbol;
        price.innerHTML = `${targetCurrency.value} ${targetCurrency.symbol}`;
        image.setAttribute('src', `${window.exchange_rates_data.icon_directory_uri}/dist/images/currency-icons/${targetCurrency.symbol}.svg`);

        if (isNaN(parseFloat(baseInput.value))) {
            targetInput.value = this.roundInputValue(targetCurrency, 0);
        } else {
            targetInput.value = this.roundInputValue(targetCurrency, parseFloat(baseInput.value) * targetCurrency.value);
        }

        const activeOption = dropdown.querySelector(`[data-dropdown-option="${targetCurrency.symbol}"]`);
        activeOption.classList.add('option-active');
    }

    formatDropdownOption(currency) {
        return `
            <div class="hover:bg-grey-50 flex flex-wrap items-center rounded-lg py-[7px] px-[10px] cursor-pointer" data-dropdown-option="${currency.symbol}">
                <div class="w-[28px] h-[28px] bg-white rounded-full flex flex-wrap items-center justify-center mr-2">
                    <img class="w-[24px] h-[24px]" src="${window.exchange_rates_data.icon_directory_uri}/dist/images/currency-icons/${currency.symbol}.svg" alt="${currency.symbol}">
                </div>
                <span class="text-sm text-grey-600" data-dropdown-option-title>
                    ${currency.title}
                </span>
            </div>
        `;
    }

    changeInputValue() {
        const baseInput = this.selector.querySelector('[data-dropdown-input="base"]');
        const targetInput = this.selector.querySelector('[data-dropdown-input="target"]');

        if (!baseInput || !targetInput) {
            return;
        }

        baseInput.addEventListener('input', () => {
            baseInput.value = this.validateInputValue(baseInput.value);

            const baseCurrency = window.exchange_rates_data.data.find(obj => obj.symbol === window.exchange_rates_data.base);
            const targetCurrency = baseCurrency.rates.find(obj => obj.symbol === window.exchange_rates_data.target);

            if (baseInput.value === '') {
                targetInput.value = this.roundInputValue(targetCurrency, 0);
            } else {
                targetInput.value = this.roundInputValue(targetCurrency, parseFloat(baseInput.value) * targetCurrency.value);
            }
        });

        targetInput.addEventListener('input', () => {
            targetInput.value = this.validateInputValue(targetInput.value);

            const targetCurrency = window.exchange_rates_data.data.find(obj => obj.symbol === window.exchange_rates_data.target);
            const baseCurrency = targetCurrency.rates.find(obj => obj.symbol === window.exchange_rates_data.base);

            if (targetInput.value === '') {
                baseInput.value = this.roundInputValue(baseCurrency, 0);
            } else {
                baseInput.value = this.roundInputValue(baseCurrency, parseFloat(targetInput.value) * baseCurrency.value);
            }
        });
    }

    validateInputValue(value) {
        value = value.replace(/[^0-9.,]/g, '');
        value = value.replace(',', '.');

        const parts = value.split('.');

        if (parts.length > 2) {
            value = parts[0] + '.' + parts[1];
        }

        if (value.startsWith('.')) {
            value = '0' + value;
        }

        const decimalIndex = value.indexOf('.');
        if (decimalIndex !== -1 && value.length > decimalIndex + 9) {
            value = value.substring(0, decimalIndex + 9);
        }

        return value;
    }

    roundInputValue(currency, value) {
        let decimals = 8;

        if (currency.kind === 'fiat') {
            decimals = 2;
        } else if (currency.kind === 'crypto' && currency.stablecoin) {
            decimals = 4;
        }

        return parseFloat(value).toFixed(decimals).replace(/(\.\d{2}\d*?)0+$/, '$1');
    }

    switch() {
        const button = this.selector.querySelector('[data-switch]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            const oldBase = window.exchange_rates_data.base;
            const oldTarget = window.exchange_rates_data.target;

            window.exchange_rates_data.base = oldTarget;
            window.exchange_rates_data.target = oldBase;

            this.renderBaseDropdown();
            this.renderTargetDropdown();
            this.updateCurrencies();
        });
    }

    updateCurrencies() {
        const baseLabels = this.selector.querySelectorAll('[data-base-currency]');
        const targetLabels = this.selector.querySelectorAll('[data-target-currency]');

        history.replaceState(
            {},
            '',
            `${window.exchange_rates_data.root_url}/${window.exchange_rates_data.base}/${window.exchange_rates_data.target}`
        );

        baseLabels.forEach((label) => {
            label.innerHTML = window.exchange_rates_data.base;
        });

        targetLabels.forEach((label) => {
            label.innerHTML = window.exchange_rates_data.target;
        });
    }

    refresh() {
        const button = this.selector.querySelector('[data-refresh]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            button.classList.add('pointer-events-none');

            fetch('/wp-json/internal/exchange-rates/refresh', {
                method: 'POST',
            })
            .then(response => {
                if (response.ok) {
                    window.location.reload();
                    return;
                }

                button.classList.remove('pointer-events-none');
                console.error('HTTP Error:', response.status);
            })
            .catch(error => {
                button.classList.remove('pointer-events-none');
                console.error('Error:', error);
            });
        })
    }
}